export const getMaxPricingDetailsDiscountPercent = pricingDetails => {
  const percents = (pricingDetails ?? []).map(pricingDetail => {
    var _pricingDetail$finalP;
    return Number(((_pricingDetail$finalP = pricingDetail.finalPrice) == null || (_pricingDetail$finalP = _pricingDetail$finalP.discount) == null || (_pricingDetail$finalP = _pricingDetail$finalP.percent) == null ? void 0 : _pricingDetail$finalP.amount) ?? 0);
  }).filter(percent => percent > 0);
  if (!percents.length) {
    return undefined;
  }
  return Math.max(...percents);
};
//# sourceMappingURL=discount-utils.js.map